import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "staff-page" }
const _hoisted_2 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_3 = {
  key: 1,
  role: "alert",
  class: "ui-alert ui-alert--error"
}
const _hoisted_4 = { class: "page-heading" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "catalog-icon" }
const _hoisted_7 = ["src", "alt"]

import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { Package, ArrowLeft } from '@lucide/vue';

import { onMounted, ref } from 'vue';
import axios from 'axios';
import ProductModulesTree from '@/components/ProductModulesTree.vue';

interface Props {
  id: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCatalogDetail',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const loading = ref(false);
const errorMessage = ref('');
const product = ref<Product | null>(null);

async function loadProduct() {
  loading.value = true;
  errorMessage.value = '';
  try {
    product.value = (await axios.get(`/api/products/${props.id}/`)).data as Product;
  } catch (error) {
    console.error('Failed to load product details:', error);
    errorMessage.value = 'Не удалось загрузить карточку продукта';
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await loadProduct();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Spinner)),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Загрузка продукта…", -1))
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage.value), 1))
        : (product.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_unref(Button), {
                "as-child": "",
                variant: "ghost",
                class: "mb-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: { name: 'products' } }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowLeft), { size: 16 }),
                      _cache[1] || (_cache[1] = _createTextVNode(" К списку продуктов ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("header", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    (product.value.icon)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: product.value.icon,
                          alt: product.value.name
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createBlock(_unref(Package), {
                          key: 1,
                          size: 26
                        }))
                  ]),
                  _createElementVNode("h1", null, _toDisplayString(product.value.name), 1)
                ])
              ]),
              _createVNode(ProductModulesTree, {
                modules: product.value.modules || []
              }, null, 8, ["modules"])
            ], 64))
          : _createCommentVNode("", true)
  ]))
}
}

})